import { FilterChip, ScrollView, XStack, YStack } from "@medbillai/ui";
import { PersonPicker } from "./PersonPicker";
import type { Person, RecordFilters, StatusFilter } from "./records";
const STATUSES: {
  value: StatusFilter;
  label: string;
}[] = [{
  value: "all",
  label: "All"
}, {
  value: "needsYou",
  label: "Needs you"
}, {
  value: "inProgress",
  label: "In progress"
}, {
  value: "done",
  label: "Done"
}];
export const FilterChips = ({
  filters,
  onStatusChange,
  needsYouCount,
  people,
  onPersonChange
}: {
  filters: RecordFilters;
  onStatusChange: (status: StatusFilter) => void;
  needsYouCount: number;
  people: readonly Person[];
  onPersonChange: (person: string | undefined) => void;
}) =>
// The picker sits outside the scroller so its shadow isn't clipped.
<XStack alignItems="center" marginBottom="$sp0.5" data-sentry-element="XStack" data-sentry-component="FilterChips" data-sentry-source-file="FilterChips.tsx">
    {people.length > 0 ? <YStack paddingLeft="$sp2" paddingRight="$sp0.75">
        <PersonPicker people={people} person={filters.person} onChange={onPersonChange} />
      </YStack> : null}
    <ScrollView horizontal showsHorizontalScrollIndicator={false} flex={1} data-sentry-element="ScrollView" data-sentry-source-file="FilterChips.tsx">
      <XStack role="group" aria-label="Status" gap="$sp0.25" paddingLeft={people.length > 0 ? 0 : "$sp2"} paddingRight="$sp2" data-sentry-element="XStack" data-sentry-source-file="FilterChips.tsx">
        {STATUSES.map(({
        value,
        label
      }) => <FilterChip key={value} label={label} count={value === "needsYou" ? needsYouCount : undefined} selected={filters.status === value} onPress={() => onStatusChange(value)} />)}
      </XStack>
    </ScrollView>
  </XStack>;